import React from 'react';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import UIBox from 'components/ui/UIBox';
import UIText from 'components/ui/UIText';
import UIButton from 'components/ui/UIButton';
import { pagePaths } from 'routes/paths';

const NotFoundPage404: React.FC = () => (
  <UIBox
    sx={{
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: 2,
      py: { xs: 6, md: 10 },
    }}
  >
    <UIBox
      sx={{
        maxWidth: 560,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 3,
      }}
    >
      <UIBox
        sx={{
          width: 96,
          height: 96,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'primary.aqua',
          color: 'primary.main',
        }}
      >
        <MenuBookOutlinedIcon sx={{ fontSize: 44 }} />
      </UIBox>

      <UIText
        sx={{
          fontSize: { xs: 96, md: 144 },
          fontWeight: 700,
          lineHeight: 1,
          color: 'primary.main',
          letterSpacing: '-0.04em',
        }}
      >
        404
      </UIText>

      <UIText
        sx={{
          color: 'text.secondary',
          fontStyle: 'italic',
          mt: -1,
        }}
      >
        /four-oh-four/
      </UIText>

      <UIText variant="h3" component="h1">
        Сторінки немає у словнику
      </UIText>

      <UIText sx={{ color: 'text.secondary' }}>
        Можливо, посилання застаріле, або сторінка переїхала на іншу полицю.
        Повертайся на головну й знайди потрібне там.
      </UIText>

      <UIBox
        sx={{
          display: 'flex',
          gap: 1.5,
          mt: 1,
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}
      >
        <UIButton link={'/'}>На головну</UIButton>
        <UIButton link={`/${pagePaths.vocabulary}`} variant="text">
          До словника
        </UIButton>
      </UIBox>
    </UIBox>
  </UIBox>
);

export default NotFoundPage404;
